export const TP_BATCH_SIZE = 200;
export const TP_FETCH_CONCURRENCY = 3;
export const TP_CACHE_FRESH_MS = 5 * 60 * 1000;
export const TP_CACHE_STALE_MS = 60 * 60 * 1000;
export const TP_CACHE_PERSIST_MAX_AGE_MS = 24 * 60 * 60 * 1000;
export const TP_CACHE_STORAGE_KEY = "gw2-tp-price-cache-v1";
export const TP_CACHE_MAX_ENTRIES = 4000;
export const TP_REFRESH_INTERVAL_MS = 5 * 60 * 1000;
export const TP_HOT_ID_WINDOW_MS = 30 * 60 * 1000;

export const ITEMS_BATCH_SIZE = 200;
export const ITEMS_FETCH_CONCURRENCY = 3;
export const ITEMS_CACHE_FRESH_MS = 60 * 60 * 1000;
export const ITEMS_CACHE_STALE_MS = 24 * 60 * 60 * 1000;

export const GW2_PRICES_BASE_URL =
  "https://api.guildwars2.com/v2/commerce/prices";
export const GW2_ITEMS_BASE_URL = "https://api.guildwars2.com/v2/items";
